
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { doUpdateRelationship, setUserProfile, useUserProfile, } from "../redux/userProfile";
import Page from "@/components/layout/page";
import Avatar from "@/components/common/avatar";
import React, { useEffect, useState } from "react";
import Popup from "@/components/ui/popup";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import { getModeIcon, getModeNameCapitalFirst, getHeighestScore, } from "../util/util";
import Medal from "../components/common/medal";
import NumberDisplay from "../components/ui/number-display";
import profileStyles from "../modules/profile/Profile.module.css";
import { RelationshipStatus } from "@chesshotel/constants";
import { FullLeagueScore } from "@chesshotel/types";
import { useUser } from "../redux/user";
import { api } from "../services/api";
import { friendRequest, removeFriend, useFriends } from "../redux/friends";
import { useSiteData } from "../redux/siteData";
import { PlayerWs } from "../services/wsOutRoutes";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
export async function fetchUserById(userId: number) {
    const response = await api.get("/relationship/" + userId);
    response.data && setUserProfile(response.data);
}
interface UpdateRelationship {
    userId: number;
    username?: string;
    status: RelationshipStatus;
}
export async function updateRelationship(update: UpdateRelationship) {
    if (update.status === RelationshipStatus.PENDING) {
        friendRequest(update.userId, update.username);
    }
    else {
        const response = await api.post("/relationship/update", update);
        const status = response.data;
        if (status === RelationshipStatus.BLOCKED) {
            PlayerWs.block(update.userId, update.username);
        }
        else if (status === RelationshipStatus.DECLINED) {
            removeFriend(update.userId);
        }
        else if (status === RelationshipStatus.NONE) {
            PlayerWs.unblock(update.userId);
        }
    }
    doUpdateRelationship(update.status);
}
function UserProfile() {
    const { t } = useTranslation("common");
    const router = useRouter();
    const { userId, link } = router.query;
    const userIdNum = parseInt(userId as string);
    const { user } = useUserProfile();
    const { friendList } = useFriends();
    const { id, isGuest } = useUser();
    const [action, setAction] = useState(null);
    const { gamePath } = useSiteData();
    const [friendOpen, setFriendOpen] = useState(false);
    useEffect(() => {
        if (userIdNum)
            fetchUserById(userIdNum);
    }, [userIdNum, friendList]);
    const isLoading = !user || user.id !== userIdNum;
    function renderButtons() {
        function renderBlockButton() {
            if (user.status !== RelationshipStatus.ACCEPTED &&
                user.status !== RelationshipStatus.PENDING) {
                if (user.status === RelationshipStatus.BLOCKED) {
                    return (<Button size="sm" variant="outline" className="font-medium text-red-500 border-red-500 hover:border-red-600 hover:text-red-600 hover:bg-white" onClick={() => {
                            setAction("unblock");
                            setFriendOpen(true);
                        }}>
              {t("Blocked")}
            </Button>);
                }
                else {
                    return (<Button size="sm" variant="outline" className="font-medium text-red-500 border-red-500 hover:border-red-600 hover:text-red-600 hover:bg-white" onClick={() => {
                            setAction("block");
                            setFriendOpen(true);
                        }}>
              {t("Block")}
            </Button>);
                }
            }
        }
        function renderFriendButton() {
            if (user.status !== RelationshipStatus.BLOCKED) {
                if (user.status === RelationshipStatus.ACCEPTED) {
                    return (<Button size="sm" variant="default" onClick={() => {
                            setAction("unfriend");
                            setFriendOpen(true);
                        }}>
              {t("Friend")}
            </Button>);
                }
                else if (user.status === RelationshipStatus.PENDING) {
                    return (<Button size="sm" variant="default" onClick={() => {
                            setAction("removeRequest");
                            setFriendOpen(true);
                        }}>
              {t("Friend request sent")}
            </Button>);
                }
                else {
                    return (<Button variant="default" size="sm" onClick={() => updateRelationship({
                            userId: user.id,
                            username: user.username,
                            status: RelationshipStatus.PENDING,
                        })}>
              {t("Add friend")}
            </Button>);
                }
            }
        }
        return (<div className="flex items-center gap-2">
        {renderFriendButton()}
        {renderBlockButton()}
      </div>);
    }
    function renderElo() {
        return user.scores.map((score) => {
            return (<NumberDisplay title={getModeNameCapitalFirst(score.modeId, t)} number={score.elo} fontawesomeIcon={getModeIcon(score.modeId)}/>);
        });
    }
    function renderMedals() {
        return user.scores.map((score) => {
            const leagueNameStr = score.leagueName + " league";
            const tranlatedLeagueName = t(leagueNameStr).toUpperCase();
            return (<div className="flex flex-col items-center pb-8">
          {/* <div className="flex items-center space-x-1"> */}
          {/* <div className="flex justify-center items-center rounded-full">
                  {getModeIcon(score.modeId)}
                </div> */}
          <div className="mb-1.5 font-semibold">
            {getModeNameCapitalFirst(score.modeId, t)}
          </div>
          {/* </div> */}
          <span className="has-tooltip">
            <span className="tooltip">
              {getModeNameCapitalFirst(score.modeId, t).toUpperCase() +
                    " " +
                    tranlatedLeagueName}
            </span>
            <Medal rank={score.rank} title="RANK" leagueName={score.leagueName} size={"medium"}/>
          </span>
        </div>);
        });
    }
    function renderModal() {
        let header = "";
        let status;
        let btnTitle = "";
        let btnClass = "";
        if (action === "block") {
            header = t("Block") + " " + user.username + "?";
            status = RelationshipStatus.BLOCKED;
            btnTitle = t("Block");
            btnClass = "btn-red btn-base";
        }
        else if (action === "unfriend") {
            header = t("Remove friend") + " " + user.username + "?";
            status = RelationshipStatus.DECLINED;
            btnTitle = t("Remove friend");
        }
        else if (action === "unblock") {
            header = t("Unblock") + " " + user.username + "?";
            status = RelationshipStatus.NONE;
            btnTitle = t("Unblock");
        }
        else if (action === "removeRequest") {
            header = t("Remove friend request");
            status = RelationshipStatus.NONE;
            btnTitle = t("Remove request");
        }
        return (<Popup title={header} onClose={() => setFriendOpen(false)}>
        <Button variant="default" size="wide" className={btnClass} onClick={() => {
                setFriendOpen(false);
                updateRelationship({
                    userId: user.id,
                    username: user.username,
                    status,
                });
            }}>
          {btnTitle}
        </Button>
        <Button variant="outline" size="wide" className="ml-3" onClick={() => setFriendOpen(false)}>
          {t("Cancel")}
        </Button>
      </Popup>);
    }
    function getPrevLink(location) {
        if (location === "/friends") {
            return t("Friends");
        }
        if (location === "/players") {
            return t("Players");
        }
        if (location === gamePath) {
            return t("Game");
        }
    }
    const score: FullLeagueScore = isLoading
        ? null
        : getHeighestScore(user.scores);
    const prevLabel = typeof link === "string" ? getPrevLink("/" + link) : undefined;
    const pageTitle = (<div className="w-full">
      {prevLabel && (<button type="button" className="w-fit text-sm font-medium text-orange-400 hover:text-orange-500" onClick={() => router.back()}>
          {"\u2190"}{" "}
          {t("Back to {{destination}}", { destination: prevLabel })}
        </button>)}
      {isLoading ? (<div className="flex flex-col gap-3 mt-2 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <Skeleton className="w-14 h-14 rounded-full md:w-16 md:h-16"/>
            <div className="flex flex-col gap-1">
              <Skeleton className="w-40 h-9"/>
              <Skeleton className="w-24 h-5"/>
            </div>
          </div>
          <div className="hidden items-center gap-2 md:flex">
            <Skeleton className="w-28 h-9 rounded-md"/>
            <Skeleton className="w-20 h-9 rounded-md"/>
          </div>
        </div>) : (<div className="flex flex-col gap-3 mt-2 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <Avatar className="w-14 h-14 md:w-16 md:h-16" id={user.id} avatarType={user.avatarType} avatarId={user.avatarId} fbId={user.fbId} googleId={user.googleId}/>
            <div className="flex flex-col items-start">
              <div className="text-3xl font-semibold leading-tight">
                {user.username}
              </div>
              {score && (<span className="has-tooltip">
                  <span className="tooltip">
                    {getModeNameCapitalFirst(score.modeId, t)}
                  </span>
                  <div className="flex items-center space-x-1 text-base text-muted-foreground">
                    <div>{getModeIcon(score.modeId)}</div>
                    <div>{score.elo}</div>
                  </div>
                </span>)}
            </div>
          </div>

          {user.id !== id && !isGuest && renderButtons()}
        </div>)}
    </div>);
    // Skeleton loading state
    if (isLoading) {
        return (<Page title={pageTitle} padded>
        <Skeleton className="py-4 pb-10 mb-4 w-24 h-4"/>
        <div className="flex flex-col flex-wrap items-center mt-5 mb-9 -ml-2 md:flex-row">
          <Skeleton className="m-2 w-48 h-24 rounded-md"/>
          <Skeleton className="m-2 w-48 h-24 rounded-md"/>
          <Skeleton className="m-2 w-48 h-24 rounded-md"/>
        </div>

        <Skeleton className="mb-4 w-20 h-4"/>
        <div className="grid grid-cols-2 gap-6 pb-[30px] md:grid-cols-4">
          <div className="flex flex-col items-center pb-8">
            <Skeleton className="mb-2 w-16 h-4"/>
            <Skeleton className="w-20 h-32 rounded-md"/>
          </div>
          <div className="flex flex-col items-center pb-8">
            <Skeleton className="mb-2 w-16 h-4"/>
            <Skeleton className="w-20 h-32 rounded-md"/>
          </div>
          <div className="flex flex-col items-center pb-8">
            <Skeleton className="mb-2 w-16 h-4"/>
            <Skeleton className="w-20 h-32 rounded-md"/>
          </div>
          <div className="flex flex-col items-center pb-8">
            <Skeleton className="mb-2 w-16 h-4"/>
            <Skeleton className="w-20 h-32 rounded-md"/>
          </div>
        </div>
      </Page>);
    }
    return (<Page title={pageTitle} padded>
      {friendOpen && renderModal()}
      {user.scores && user.scores.length > 0 && (<>
          <div className={profileStyles.seasonTitle} style={{ width: "100%" }}>
            {t("Ratings").toUpperCase()}
          </div>
          <div className="flex flex-col flex-wrap items-center mt-5 mb-9 -ml-2 md:flex-row">
            {user.scores && renderElo()}
          </div>
          <div className={profileStyles.seasonTitle} style={{ width: "100%" }}>
            {t("Medals").toUpperCase()}
          </div>
          <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
            {renderMedals()}
          </div>
        </>)}
    </Page>);
}
export default UserProfile;

    async function __Next_Translate__getStaticProps__19e2b2a3f3f__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/user',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19e2b2a3f3f__ as getStaticProps }
  